import React, { FunctionComponent, useState } from 'react';

import { isGettyClient } from '@helpers/getty-strings';

import classes from './styles/brandguide-announcement.module.scss';

export const BrandguideAnnouncement: FunctionComponent = () => {
  const key = 'bf-boulder-brandguide-v2-announcement';

  const [show, setShow] = useState(localStorage.getItem(key) === 'false' ? false : true);

  const handleDismiss = (): void => {
    setShow(false);
    localStorage.setItem(key, 'false');
  };

  if (!show) return null;

  const href = isGettyClient() ? 'https://damhelp.gettyimages.com/en/article/brandguide-tutorial' : 'https://help.brandfolder.com/hc/en-us/articles/12052930317463';

  return (
    <div className={classes.brandguideAnnouncement}>
      <p className={classes.brandguideAnnouncementText}>
        Say hello <span aria-hidden role="img">👋</span> to the NEW! Brandguide.
        <a
          className={classes.brandguideAnnouncementLink}
          href={href}
          rel="noreferrer"
          target="_blank"
        >
            Learn More.
        </a>
      </p>
      <button
        className={classes.brandguideAnnouncementButton}
        onClick={(): void => handleDismiss()}
        type="button">
          x
      </button>
    </div>
  );
};